<template>
  <create-account-layout
    :current-step="2"
    :title="
      challenge_failed == true ? 'Verification Failed' : 'Carrier Details'
    "
  >
    <form
      novalidate="novalidate"
      @submit.prevent="handleSubmit"
    >
      <div v-if="challenge_failed == false">
        <div class="flex flex-col items-start">
          <p class="flex flex-col pb-2 text-left text-sm">
            {{ challengeQuestion }}
          </p>
          <round-radio-button
            v-for="(option, index) in challengeAnswerOptions"
            :key="`challenge-question-option-${index}`"
            :class="
              dispatcher_carrier_verification_answer === option
                ? 'mb-2 w-full border-yellow-500'
                : 'mb-2 w-full'
            "
            :item="option"
            :value="option"
            name="verification_challenge"
            :handle-click="() => handleUpdate(option)"
            :checked="dispatcher_carrier_verification_answer === option"
          />
        </div>
        <button-main
          class="my-3 mb-4"
          :disabled="!dispatcher_carrier_verification_answer"
          type="submit"
          :loading-spinner="isLoading"
          value="Continue"
        />
      </div>
      <div v-else>
        <div class="flex flex-col items-start">
          <p class="flex flex-col pb-2 text-left text-sm">
            You have failed the validation process required to join this
            carrier.
          </p>
          <p class="flex flex-col pb-2 text-left text-sm">
            If you would like to continue the validation process, please click
            the button below to contact us so that we may assist you in
            verifying your account.
          </p>
        </div>
        <button-main
          class="my-3 mb-4"
          :disabled="false"
          type="button"
          value="Contact Highway"
          @click="showContactUsModal = true"
        >
          Contact Highway
        </button-main>
      </div>
    </form>
  </create-account-layout>
  <contact-us-modal
    v-if="showContactUsModal"
    :visible="showContactUsModal"
    @close="onCloseContactUsModal"
  />
</template>

<script>
import CreateAccountLayout from '@/components/layouts/CreateAccountLayout.vue';
import ButtonMain from '@/components/Button.vue';
import RoundRadioButton from '@/components/RoundRadioButton.vue';
import contactUs from '@/mixins/contactUs';
import { toastResponse } from '@/common/handleServerResponse';

export default {
  name: 'VerificationChallenge',
  components: {
    CreateAccountLayout,
    ButtonMain,
    RoundRadioButton,
  },
  mixins: [contactUs],
  data() {
    return {
      isLoading: false,
      dispatcher_carrier_verification_answer: '',
      challenge_failed: false,
      showContactUsModal: false,
    };
  },
  computed: {
    carrierId() {
      return (
        this.$store.state.carriers?.carrierDetails?.id ||
        this.$store.state.users?.currentUser?.requested_carrier_id
      );
    },
    challengeQuestion() {
      return this.$store.state.verifications?.dispatcher_challenge_question;
    },
    challengeAnswerOptions() {
      return this.$store.state.verifications
        ?.dispatcher_challenge_question_answer_options;
    },
  },
  async mounted() {
    try {
      await this.$store.dispatch('users/refreshCurrentUser');
    } catch (error) {
      console.error('ERROR:', error);
      this.$router.push({ name: 'RequestAccess' });
    }
  },
  methods: {
    handleUpdate(value) {
      this.dispatcher_carrier_verification_answer = value;
      this.$store.commit('verifications/setDispatcherChallengeAnswer', value);
    },
    async createDispatcherConnection() {
      console.log('creating dispatcher connection');
      const res = await this.$store.dispatch(
        'dispatchers/createDispatcherConnection',
        {
          carrier_id: this.carrierId,
        }
      );
      if ([200, 201].includes(res.status)) {
        await this.redirectToCreateDispatcherOnboardingPacket();
      } else {
        // handle error for updating user details
        toastResponse(this, res, null);
      }
    },
    // Redirect to OAuth 2 screen if able to
    // create the onboarding packet
    async redirectToCreateDispatcherOnboardingPacket() {
      await this.$store.dispatch('users/serverRefreshCurrentUser');

      console.log('creating onboarding packet');
      const clientId = localStorage.getItem('client_id');
      if (clientId == null) {
        // if there is not client_id in local storage, then
        // send the user to the dashboard
        return this.$router.push({ name: 'Dispatcher Dashboard' });
      }
      let redirectAfterSignIn = JSON.parse(
        localStorage.getItem('redirect_url_after_sigin')
      );
      // If they have a redirect_url_after_signin, take them
      // there else send them to the dashboard
      if (redirectAfterSignIn) {
        // Set the state.dispatchers.selectedCarrierId before
        // going back to OAuth screen in this special use case
        // where they chose the carrier when they signed up
        await this.$store.commit(
          'dispatchers/setSelectedCarrierId',
          this.carrierId
        );
        localStorage.removeItem('redirect_url_after_sigin');
        this.$router.push(redirectAfterSignIn);
      } else {
        return this.$router.push({ name: 'Dispatcher Dashboard' });
      }
    },
    async handleSubmit() {
      this.isLoading = true;
      try {
        const res = await this.$store.dispatch(
          'verifications/verifyDispatcherChallengeQuestion'
        );
        if (res == 'dispatcher_challenge_successful') {
          // Force the user to refresh because we now are associated
          // with a company
          this.isLoading = true;
          this.validation_error = false;
          await this.createDispatcherConnection();
          this.isLoading = false;
        } else {
          this.validation_error = true;
          this.challenge_failed = true;
        }
      } catch (error) {
        console.log('ERROR: ', error);
        throw error;
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>
